import React from 'react';

import {
	stringToHslColor,
	getPersonInitials,
	useClassNames,
} from '@common';

import './Avatar.scss';

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement>{
	name?: string,
	avatarSrc?: string,
}

function Avatar(props: AvatarProps): JSX.Element {
	const {
		className,
		avatarSrc,
		name,
		...otherProps
	} = props;

	function viewWithAvatar(): JSX.Element {
		return (
			<img src={avatarSrc} className="avatar__image" alt="avatar" />
		);
	}

	function viewWithoutAvatar(): JSX.Element {
		const organizerTheme = {
			backgroundColor: stringToHslColor(name, 50, 90),
			color: stringToHslColor(name, 100, 20),
		};

		return (
			<div className="avatar__placeholder" style={organizerTheme} title={name}>
				{getPersonInitials(name)}
			</div>
		);
	}

	const classes = useClassNames('avatar', className);

	return (
		<div className={classes} {...otherProps}>
			{
				avatarSrc
					? viewWithAvatar()
					: viewWithoutAvatar()
			}
		</div>
	);
}

export {Avatar};